import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';

const DOMstrings = {
	paginationWrapper: '.pagination',
	paginationSlider: '.pagination__slider',
	paginationCenter: '.pagination__center',
	btnNext: '.nav-item.next',
	btnPrev: '.nav-item.prev',
	btnFirst: '.nav-item.first',
	btnLast: '.nav-item.last',
};

const initializePagination = (pageNumber: number) => {
	document.querySelectorAll(DOMstrings.paginationWrapper).forEach((paginationEl) => {
		const options: SwiperOptions = {
			modules: [Navigation],
			initialSlide: pageNumber - 1,
			direction: 'vertical',
			loop: false,
			slideToClickedSlide: true,
			mousewheel: true,
			keyboard: true,
			navigation: {
				nextEl: paginationEl.querySelector<HTMLElement>(DOMstrings.btnNext),
				prevEl: paginationEl.querySelector<HTMLElement>(DOMstrings.btnPrev),
				disabledClass: 'disabled',
			},
		};

		if (window.innerWidth >= 1024) {
			options.on = {
				click: () => {
					const paginationCenter = paginationEl.querySelector(DOMstrings.paginationCenter);
					paginationCenter?.classList.toggle('open');
				},
			};
		}

		const pageSliderEl = paginationEl.querySelector<HTMLElement>(DOMstrings.paginationSlider);
		if (!pageSliderEl) return;

		const pageSlider = new Swiper(pageSliderEl, options);

		if (paginationEl.querySelector(DOMstrings.btnFirst)) {
			const btnFirst = paginationEl.querySelector(DOMstrings.btnFirst);
			btnFirst?.addEventListener('click', () => {
				pageSlider.slideTo(0);
			});
		}

		if (paginationEl.querySelector(DOMstrings.btnLast)) {
			const btnLast = paginationEl.querySelector(DOMstrings.btnLast);
			btnLast?.addEventListener('click', () => {
				pageSlider.slideTo(pageSlider.slides.length);
			});
		}
	});

	document.dispatchEvent(new CustomEvent('afterPaginationInit'));
};

initializePagination(1);
document.addEventListener('postsLoaded', (e) => {
	if (!(e instanceof CustomEvent)) return;

	initializePagination(Number(e.detail));
});
